import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

/**
 * Vuetify 3 config — STARS dark theme.
 *
 * Brand primary: #E4003F (vibrant red).
 * Dark palette inspired by modern admin panels: near-black background
 * (#0f0f11), elevated surfaces (#1c1d21), zinc accents (#27272a).
 * Poppins is loaded globally via @fontsource and applied in global.css.
 */
export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'starsDark',
    themes: {
      starsDark: {
        dark: true,
        colors: {
          background: '#0f0f11',
          surface: '#1c1d21',
          'surface-variant': '#27272a',
          'on-surface': '#e4e4e7',
          'on-background': '#e4e4e7',
          primary: '#E4003F',
          'primary-darken-1': '#B80032',
          secondary: '#27272a',
          accent: '#E4003F',
          error: '#ef4444',
          info: '#3b82f6',
          success: '#22c55e',
          warning: '#f59e0b',
        },
      },
    },
  },
  defaults: {
    VCard: {
      rounded: 'lg',
      elevation: 0,
      color: 'surface',
    },
    VBtn: {
      rounded: 'lg',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VDataTableServer: {
      hover: true,
    },
    VNavigationDrawer: {
      color: 'surface',
    },
  },
});
